// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__3vsmE","Menu__title":"Menu_Menu__title__1UtAL","Menu__list":"Menu_Menu__list__1b-mV","Menu__bottom":"Menu_Menu__bottom__1GP7v","fadein":"Menu_fadein__5qh7r"};